import {Helmet} from '@dr.pogodin/react-helmet';

import {useParams} from 'react-router-dom';

import {isNil} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetHandlingUnitQuery} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {SettingsTemplate, SettingsTemplateHeader} from '@dms/settings/shared';
import {usePermissions} from '@dms/shared';

import {MeasurementUnitsDetailForm} from './components/MeasurementUnitsDetailForm';

export function WarehousesMeasurementUnitsDetail() {
  const {id} = useParams();

  const [warehouseDictionaryEdit, warehouseDictionaryCreate] = usePermissions({
    permissionKeys: ['warehouseDictionaryEdit', 'warehouseDictionaryCreate'],
  });

  const {
    data: measurementUnit,
    isLoading,
    isError,
  } = useGetHandlingUnitQuery({id: id as string}, {skip: isNilOrEmpty(id)});

  // Check edit permission only if id is not nil that means that the user is creating a new measurement unit
  const isEditDisabled = isNil(id) ? !warehouseDictionaryCreate : !warehouseDictionaryEdit;

  const header: SettingsTemplateHeader = {
    title: isNil(id)
      ? i18n.t('entity.warehouse.actions.newMeasurementUnit')
      : (measurementUnit?.description ?? ''),
    alerts: isEditDisabled
      ? [
          {
            type: 'banner',
            variant: 'info',
            message: i18n.t('module.warehouse.label.missingWarehouseDictionaryEditPermission'),
          },
        ]
      : undefined,
  };

  return (
    <>
      <Helmet title={i18n.t('entity.warehouse.labels.measurementUnitDetail')} />
      <SettingsTemplate
        header={header}
        isLoading={isLoading}
        isError={isError}
        data-testid={testIds.settings.warehousesMeasurementUnitsDetail('template')}
      >
        <MeasurementUnitsDetailForm
          measurementUnit={measurementUnit}
          isEditDisabled={isEditDisabled}
          data-testid={testIds.settings.warehousesMeasurementUnitsDetail(
            'measurementUnitsDetailForm'
          )}
        />
      </SettingsTemplate>
    </>
  );
}
